import React, {useEffect} from "react";
import { Checkbox, FormControlLabel, Box, Grid } from "@mui/material";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  inputField: {
    width: "100%",
    margin: theme.spacing(1, 0),
  },
}));

const GuardianInfo = ({ register, errors, setValue, formData, updateFormData, language }) => {
  const _resources = language
  const classes = useStyles();

  const handleRestrictedTextInput = (event) => {
    const isFirstChar = event.target.selectionStart === 0;

    if (event.key === " " && isFirstChar) {
      event.preventDefault();
      return;
    }

  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
          name="guardianCompletedForms"
          color="primary"
          onChange={(e) => {
            const isChecked = e.target.checked;
            setValue("guardianCompletedForms", isChecked);
            updateFormData({
              ...formData,
              guardianCompletedForms: isChecked,
              ...(isChecked ? {} : {
                guardianFirstName: "",
                guardianLastName: "",
                guardianRelationship: "",
              }),
            });
          }}
          checked={!!formData.guardianCompletedForms}
          />
        }
        label={_resources.Checkin.GUARD_TITLE}
      />

      {formData.guardianCompletedForms && (
        <Box sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <div className="patient-heading">
              <p>{_resources.Checkin.GUARD_INFO}</p>
            </div>
          </Grid>
          <Grid container>
            {/* First Name and Last Name in one row on md and up */}
            <Grid item xs={12} md={6}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={_resources.PatientInformation.FIRST_NAME}
                defaultValue={formData.guardianFirstName || ""}
                name="guardianFirstName"
                onChange={(e) => {
                  setValue("guardianFirstName", e.target.value);
                  updateFormData({
                    ...formData,
                    guardianFirstName: e.target.value,
                  });
                }}
                inputRef={register({
                  required: _resources.PatientInformation.FIRST_NAME_REQ,
                })}
                onKeyDown={handleRestrictedTextInput}
                className={classes.inputField}
                error={Boolean(errors.guardianFirstName)}
                helperText={errors.guardianFirstName?.message}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={_resources.Checkin.LAST_NAME}
                defaultValue={formData.guardianLastName || ""}
                name="guardianLastName"
                onChange={(e) => {
                  setValue("guardianLastName", e.target.value);
                  updateFormData({
                    ...formData,
                    guardianLastName: e.target.value,
                  });
                }}
                inputRef={register({
                  required: _resources.Checkin.REQ_LAST_NAME,
                })}
                onKeyDown={handleRestrictedTextInput}
                className={classes.inputField}
                error={Boolean(errors.guardianLastName)}
                helperText={errors.guardianLastName?.message}
              />
            </Grid>

            {/* Relation always on its own row */}
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label={_resources.Checkin.RELATION_PAT}
                value={formData.guardianRelationship}
                name="guardianRelationship"
                onChange={(e) => {
                  setValue("guardianRelationship", e.target.value);
                  updateFormData({
                    ...formData,
                    guardianRelationship: e.target.value,
                  });
                }}
                inputRef={register({
                  required: _resources.Checkin.REQ_RELATION_PAT,
                })}
                onKeyDown={handleRestrictedTextInput}
                className={classes.inputField}
                error={Boolean(errors.guardianRelationship)}
                helperText={errors.guardianRelationship?.message}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default GuardianInfo;
